export const yearlyQuarters = [
    // { id: -1, name: 'Select Quarter' },
    { id: 1, name: 'Q1' },
    { id: 2, name: 'Q2' },
    { id: 3, name: 'Q3' },
    { id: 4, name: 'Q4' },
]